document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-mc-buy-now]');
  if (!button || button.disabled) return;

  const productForm = button.closest('product-form');
  const form = productForm && productForm.querySelector('form');
  if (!form) return;

  event.preventDefault();
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  try {
    const data = new FormData(form);
    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: data,
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Ajout impossible');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.assign(`${root}checkout`);
  } catch (error) {
    const message = productForm.querySelector('.product-form__error-message');
    const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    if (message) message.textContent = error.message;
    if (wrapper) wrapper.hidden = false;
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
